module.exports = __webpack_public_path__ + "static/media/011-zimbabwe.d488e1ac.svg";